export enum AlertSeverity {
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
  CAUTION = 'caution',
  DANGER = 'danger',
  SYSTEM = 'system',
}
